export const hasReferrer = (caseData: any) => !!caseData?.referrer;
